export default class Profile {

    /**
     * Create new Profile Instance.
     */
    constructor (ref) {
        this.uid = ref.uid || ''
        this.email = ref.email || ''
        this.displayName = ref.displayName || ''
        this.phone = ref.phone || ""
        this.city = ref.city || ""
        this.role = ref.role || ""
        this.FIO = ref.FIO || ""
        this.passport = ref.passport || ""
        this.address = ref.address || ""
        this.photoURL = ref.photoURL || ""
    }

    /**
     * Export to Json.
     */
    toJson () {
        return {
            email: this.email,
            displayName: this.displayName,
            phone: this.phone,
            city: this.city ,
            role: this.role,
            FIO: this.FIO,
            passport: this.passport,
            address: this.address,
            photoURL: this.photoURL
        }
    }
}



// WEBPACK FOOTER //
// ./src/models/Profile.js